// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.arrow-collapsed {
    width: 26px !important;
    height: 26px !important;
    border-radius: 40px;
    background-color: #ffffff;
    color: #7f7f7f;
    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(25, 15, 15, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
    cursor: pointer;
    inset-block-start: 100px;
    margin-left: -12px;
}

.layout-ant-menu {
    aside, .ant-layout-sider {
        height: 100% !important;
        position: fixed !important;
        overflow-y: scroll;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/menu/new-menu.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,oHAAoH;IACpH,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI;QACI,uBAAuB;QACvB,0BAA0B;QAC1B,kBAAkB;IACtB;AACJ","sourcesContent":["\n.arrow-collapsed {\n    width: 26px !important;\n    height: 26px !important;\n    border-radius: 40px;\n    background-color: #ffffff;\n    color: #7f7f7f;\n    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(25, 15, 15, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);\n    cursor: pointer;\n    inset-block-start: 100px;\n    margin-left: -12px;\n}\n\n.layout-ant-menu {\n    aside, .ant-layout-sider {\n        height: 100% !important;\n        position: fixed !important;\n        overflow-y: scroll;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
